module.exports = __webpack_public_path__ + "img/drops-bg2.88b11a6c.jpg";